import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { goToEffice, selectCurrentRoot } from "slices/efficeTreeSlice";
import { makeSelectNotify } from "slices/sharedSelectors";
import EfficeIcon from "components/Home/ui/EfficeIcon";
import EfficeTitle from "components/Home/ui/EfficeTitle";
import EfficeDot from "components/Home/ui/EfficeDot";
import EfsTippy from "components/HOCS/EfsTippy";

const RenderedRootSingle = ({ id, currentActiveAlive }) => {
  const selectNotify = useMemo(makeSelectNotify, []);

  const isActive = useSelector((state) => selectCurrentRoot(state) === id);
  const notify = useSelector((state) => selectNotify(state, id));
  const efficeData = useSelector((state) => state.efficeCache.data[id]);

  window.efs_debug && window.log("RENDERED ROOT SINGLE", 2);
  return (
    <EfsTippy
      placement="right"
      className="root-Tippy"
      disabled={!currentActiveAlive}
      content={efficeData.content}
    >
      <div
        key={id}
        onClick={(e) => goToEffice(id, true)}
        className={`head-effice-item ${isActive ? "root-button-selected" : ""}`}
      >
        <>
          <div
            className={`effice-icon-mr-side ${
              isActive ? "root-icon-selected" : ""
            }`}
          >
            <EfficeIcon
              avatar_key={efficeData.avatar_key}
              content={efficeData.content}
            />
          </div>

          <div className="head-effice-title">
            <div className="effice-title-spaced">
              <EfficeTitle
                root={true}
                parent_id={efficeData.parent_id}
                title={efficeData.content}
                ntfy={true}
              />
              <div
                className={`d-flex ${
                  currentActiveAlive ? "head-list-dot-when-closed" : null
                }`}
              >
                <EfficeDot ntfy={notify} />
              </div>
            </div>
          </div>
        </>
      </div>
    </EfsTippy>
  );
};

export default RenderedRootSingle;
